<eds-panel [hasBorders]="true" [hasBorderRadius]="true" [hasPadding]="true">
  <ng-container *ngFor="let data of finalRow">
    <div class="cards-mobile__title" *ngIf="data.colId === 'NAME'">
      <ft-regulatory-fund-name-cell-renderer [cellRendererData]="rendererData">
      </ft-regulatory-fund-name-cell-renderer>
    </div>
    <div
      *ngIf="data.colId === 'SHARE_CLASS'"
      edsFlexbox
      edsSpacing="md"
      justifyContent="space-between"
    >
      <div>{{ "literature.SHARE_CLASS" | translate }}</div>
      <div>{{ data.val }}</div>
    </div>
    <ng-container>
      <div
        edsFlexbox
        edsSpacing="md"
        *ngIf="data.colId === literatureDocType.SUMMARY_PROSPECTUS"
      >
        <ng-container *ngTemplateOutlet="dataToDisplay"></ng-container>
        <p edsSpacing="none">
          {{ "literature.SUMMARY-PROSPECTUS" | translate }}
        </p>
      </div>
      <div
        edsFlexbox
        edsSpacing="md"
        *ngIf="data.colId === literatureDocType.PROSPECTUS"
      >
        <ng-container *ngTemplateOutlet="dataToDisplay"></ng-container>
        <p edsSpacing="none">
          {{ "literature.PROSPECTUS" | translate }}
        </p>
      </div>
      <div
        edsFlexbox
        edsSpacing="md"
        *ngIf="data.colId === literatureDocType.ANNUAL_REPORT"
      >
        <ng-container *ngTemplateOutlet="dataToDisplay"></ng-container>
        <p edsSpacing="none">
          {{ "literature.ANNUAL-REPORT" | translate }}
        </p>
      </div>
      <div
        edsFlexbox
        edsSpacing="md"
        *ngIf="data.colId === literatureDocType.SEMI_ANNUAL_REPORT"
      >
        <ng-container *ngTemplateOutlet="dataToDisplay"></ng-container>
        <p edsSpacing="none">
          {{ "literature.SEMI-ANNUAL-REPORTS" | translate }}
        </p>
      </div>
      <div
        edsFlexbox
        edsSpacing="md"
        *ngIf="data.colId === literatureDocType.FISCAL_Q1_HOLDINGS"
      >
        <ng-container *ngTemplateOutlet="dataToDisplay"></ng-container>
        <p edsSpacing="none">
          {{ "literature.Q1-HOLDING" | translate }}
        </p>
      </div>
      <div
        edsFlexbox
        edsSpacing="md"
        *ngIf="data.colId === literatureDocType.FISCAL_Q3_HOLDINGS"
      >
        <ng-container *ngTemplateOutlet="dataToDisplay"></ng-container>
        <p edsSpacing="none">
          {{ "literature.Q3-HOLDING" | translate }}
        </p>
      </div>
      <div
        edsFlexbox
        edsSpacing="md"
        *ngIf="
          data.colId === literatureDocType.STATEMENT_OF_ADDITIONAL_INFORMATION
        "
      >
        <ng-container *ngTemplateOutlet="dataToDisplay"></ng-container>
        <p edsSpacing="none">
          {{ "literature.SAI" | translate }}
        </p>
      </div>
    </ng-container>
    <ng-template #dataToDisplay>
      {{ checkingDocument(data.colId) }}
      <div
        edsPadding
        edsPaddingRight="md"
        style="width: 32px"
        *ngIf="isDocumentAvailable"
      >
        <a role="button" (click)="openDocument(data.colId)">
          <eds-icon
            type="pdf"
            size="large"
            [addTitle]="'literature.pdf-icon' | translate"
          ></eds-icon>
        </a>
      </div>
      <div
        edsPadding
        edsPaddingRight="md"
        style="width: 32px"
        *ngIf="!isDocumentAvailable"
      >
        <p edsSpacing="none">
          {{ "literature.NA" | translate }}
        </p>
      </div>
    </ng-template>
  </ng-container>
</eds-panel>
